export const fi = {
  attachmentSelector: {
    title: 'Lisää liite',
    generalInfo: 'Painamalla tai raahaamalla se tähän',
    restrictionsInfo:
      '(Tiedoston maksimikoko: 10 MB. Huom! Pankkitoimintojen suojaus saattaa estää liitteiden lataamisen. Suojaus tulee poistaa käytöstä ennen liitteiden lataamista. Sallitut tiedostoformaatit: PDF, JPEG/JPG, PNG, DOC/DOCX PPT/PPTX ja XLS/XLSX)',
    loading: 'Ladataan...',
    error: {
      FileTooBig: 'Tiedosto on liian suuri',
      InvalidExtension: 'Tiedostopääte {{ext}} ei ole sallittu',
      InvalidMimeType: 'Tiedostotyyppi ei vastaa tiedostopäätettä',
      MissingExtension: 'Tiedostopääte puuttuu',
      Unknown: 'Lataus ei onnistu',
      nonEmptyArray: 'Liite puuttuu!',
      PublishFailure: 'Liitteen yhdistäminen hakemukseen ei onnistu!'
    }
  },
  breadcrumb: {
    home: 'Etusivu',
    YOUTH_PROJECT_GRANT: 'Kohdeavustus',
    YOUTH_GENERAL_GRANT: 'Yleisavustus'
  },
  common: {
    ok: 'Ok',
    cancel: 'Peruuta',
    edit: 'Muokkaa',
    modal: {
      defaultError: {
        title: 'Hups! Jotain meni vikaan',
        text: 'Tarkista yhteys ja yritä hetken kuluttua uudestaan. Jos vika jatkuu ota yhteyttä nuoriso@espoo.fi'
      },
      deleteApp: {
        title: 'Haluatko varmasti poistaa hakemuksen?',
        text: 'Hakemus ja sen tiedot poistetaan järjestelmästä',
        confirmButtonLabel: 'Poista hakemus'
      },
      sessionExpired: {
        title: 'Istuntosi on vanhentunut',
        text: 'Klikkaa OK kirjautuaksesi uudelleen'
      },
      validationErrors: {
        title: 'Tarkista kentät'
      }
    },
    statuses: {
      DRAFT: 'Luonnos',
      SIGNING: 'Odottaa allekirjoitusta',
      SENT: 'Lähetetty',
      REVIEW: 'Käsittelyssä',
      PAYMENT_WAIT: 'Myönnetty',
      PRE_REPORT: 'Myönnetty',
      REJECTED: 'Ei myönnetä',
      POST_REPORT: 'Myönnetty, maksettu',
      PAID: 'Myönnetty, maksettu',
      RECOVERY: 'Takaisinperintä',
      RECOVERED: 'Takaisinperitty'
    }
  },
  footer: {
    cityOfEspoo: 'Espoon kaupunki',
    privacyPolicy: 'Tietosuojaseloste',
    a11yStatement: 'Saavutettavuusseloste',
    feedback: 'Anna palautetta'
  },
  header: {
    nav: {
      logout: 'Kirjaudu ulos'
    },
    title: {
      label: 'Nuorisoavustukset'
    }
  },
  org: {
    additionalInfo: {
      title: 'Hakemuksen täydentävät yhteisötiedot',
      activity: {
        label: 'Toiminta',
        values: {
          EARLY_YOUTH_ACTIVITIES: 'Toiminta varhaisnuorille',
          HOBBY_CLUBS: 'Harrastekerhot',
          POLITICAL: 'Poliittinen nuoriso- ja oppilastoiminta',
          SCOUT: 'Partio',
          SPIRITUAL: 'Hengellinen toiminta',
          OTHER: 'Muu nuorisotoiminta'
        }
      },
      targetGroup: {
        label: 'Kohderyhmä',
        values: {
          ALL: 'Kaikki',
          BOYS: 'Pojat',
          GIRLS: 'Tytöt'
        }
      },
      members: {
        info: {
          label:
            'Yhteisön jäsenmäärä (espoolaisten jäsenten määrä vuoden alussa)'
        },
        from21to28: {
          label: '21–28-vuotiaat'
        },
        from29: {
          label: '29 vuotiaat ja yli'
        },
        from7to20: {
          label: '7–20-vuotiaat'
        },
        total: {
          label: 'Yhteensä jäsenet'
        }
      }
    },
    address: {
      postalAddress: {
        label: 'Postiosoite'
      },
      postalCode: {
        label: 'Postinumero'
      },
      postOffice: {
        label: 'Postitoimipaikka'
      }
    },
    areas: {
      label: 'Toiminta-alue',
      values: {
        SUUR_ESPOONLAHTI: 'Suur-Espoonlahti',
        SUUR_LEPPAVAARA: 'Suur-Leppävaara',
        SUUR_MATINKYLA: 'Suur-Matinkylä',
        SUUR_TAPIOLA: 'Suur-Tapiola',
        SUUR_KAUKLAHTI: 'Suur-Kauklahti',
        VANHA_ESPOO: 'Vanha-Espoo',
        POHJOIS_ESPOO: 'Pohjois-Espoo',
        OUTSIDE_OF_ESPOO: 'Muualla kuin Espoossa'
      }
    },
    bankAccount: {
      label: 'Tilinumero'
    },
    basicInfo: {
      label: 'Yhteisön tiedot'
    },
    businessId: {
      label: 'Y-tunnus'
    },
    domicile: {
      label: 'Kotipaikka'
    },
    email: {
      label: 'Sähköposti'
    },
    name: {
      label: 'Yhteisön nimi'
    },
    registrationDate: {
      label: 'Rekisteröitymisaika'
    },
    representativeRole: {
      CHAIRMAN: 'Pääedustaja',
      SIGNER: 'Edustaja'
    },
    representatives: {
      label: 'Yhteisön edustajat'
    },
    requiredSignersAmount: {
      label: 'Nimenkirjoittajia vähintään'
    },
    type: {
      label: 'Yhteisön tyyppi',
      ASSOCIATION: 'Yhdistys',
      COMPANY: 'Yritys',
      FOUNDATION: 'Säätiö'
    },
    wwwAddress: {
      label: 'www-osoite'
    }
  },
  validations: {
    dateWithinRange: 'Pitää olla välillä {{start}} - {{end}}',
    greaterThanOrEqual: 'Arvon on oltava {{min}} tai suurempi',
    notNil: 'Arvo puuttuu',
    required: 'Pakollinen tieto',
    withinRange: 'Pitää olla välillä {{min}}{{unit}} - {{max}}{{unit}}',
    attachmentsRequired: 'Liitteitä pitää olla vähintään {{min}}'
  },
  views: {
    generalGrant: {
      form: {
        title: 'Yleisavustus',
        appDetails: {
          title: 'Avustuksen tiedot',
          detailsOfUse: 'Haettavan avustuksen käyttötarkoitus pääkohdittain',
          appliedSumInCents: 'Haettavan avustuksen määrä'
        },
        participants: {
          title: 'Espoolaisten osallistumiskertojen määrä viime vuonna',
          desc_1:
            'Kerro kuinka monta espoolaista on osallistunut teidän tapahtumiinne',
          desc_2:
            'Esimerkki 1: Kerho oli kolme kertaa viikossa ja jokaisessa kerhossa oli 20 osallistujaa. Vuodessa kerhoja järjestettiin 40 viikkona. Yhteensä osallistumiskertoja oli 2400.',
          desc_3:
            'Esimerkki 2: Leiri kesti kolme päivää. Leirillä oli päivittäin 20 osallistujaa. Yhteensä leirillä oli 60 osallistumiskertaa',
          from7to20: '7-20 vuotiaat',
          from21to28: '21-28 vuotiaat',
          total: 'Yhteensä osallistumiskerrat:'
        },
        goals: {
          title:
            'Yhteisön toiminnan tavoitteet kuluvalle vuodelle, vähintään yksi, enintään kolme',
          goals_1: 'Tavoite 1',
          goals_2: 'Tavoite 2',
          goals_3: 'Tavoite 3'
        },
        youngEspoo: {
          link: 'https://www.espoo.fi/fi-fi/Nuoret',
          title_1: 'Miten ',
          title_link: 'Nuori Espoo',
          title_2: ' -tarina toteutuu yhteisön toiminnassa?'
        },
        financialPlan: {
          label: 'Suunnitelma yhteisön varainhankinnasta kuluvalle vuodelle',
          placeholder:
            'Yhteisön varainhankinnalla tarkoitetaan eri lähteistä haettavia avustuksia, lipputuloja, myyntituloja, jäsenmaksuja jne'
        },
        previousYear: {
          title: 'Edellisen vuoden talous',
          totalProfitInCents: 'Tilikauden tulos, euroa',
          bankAccountSumInCents:
            'Pankkitilin saldo, {{lastDayOfPreviousYear}}, euroa',
          selfAcquiredFundsInCents: 'Oma varainhankinta, euroa',
          receivedGrants: {
            label: 'Espoon kaupungilta ja muilta tahoilta saadut avustukset',
            placeholder: 'Tahon nimi ja euromäärä'
          }
        },
        attachments: {
          title: 'Liitteet',
          mandatoryAttachments: {
            title: 'Lisää tähän seuraavat pakolliset liitteet *:',
            planForYear: '- Vuoden {{year}} Toimintasuunnitelma',
            budgetForYear: '- Vuoden {{year}} Talousarvio',
            minutesOfAnnualMeeting:
              '- Vuoden {{year}} Vuosikokouksen pöytäkirjaote',
            annualReport: '- Vuoden {{year}} Vahvistettu toimintakertomus',
            financialStatemment: '- Vuoden {{year}} Vahvistettu tilinpäätös',
            auditForAYear: '- Vuoden {{year}} Toiminnantarkastus'
          }
        },
        signing: {
          title: 'Allekirjoitus',
          info: 'Allekirjoitussivulla voit vielä tarkistaa tiedot ennen allekirjoitusta'
        }
      },
      preview: {
        appDetails: 'Avustuksen tiedot',
        detailsOfUse: 'Haettavan avustuksen käyttötarkoitus',
        appliedSum: 'Haettavan avustuksen määrä',
        activity: {
          label: 'Toiminta',
          values: {
            EARLY_YOUTH_ACTIVITIES: 'Toiminta varhaisnuorille',
            HOBBY_CLUBS: 'Harrastekerhot',
            POLITICAL: 'Poliittinen nuoriso- ja oppilastoiminta',
            SCOUT: 'Partio',
            SPIRITUAL: 'Hengellinen toiminta',
            OTHER: 'Muu espoolaisille nuorille järjestetty toiminta'
          }
        },
        members: {
          label: 'Jäsenet',
          from7to20: 'Jäsenet 7-20',
          from21to28: 'Jäsenet 21-28',
          total: 'Jäsenmäärä yhteensä:'
        },
        participants: {
          label: 'Osallistumiskerrat',
          from7to20: 'Osallistumiskerrat 7-20',
          from21to28: 'Osallistumiskerrat 21-28',
          total: 'Osallistumiskerrat yhteensä:'
        },
        goals: {
          goals_1: 'Tavoite 1',
          goals_2: 'Tavoite 2',
          goals_3: 'Tavoite 3'
        },
        youngEspoo: 'Nuori Espoo -tarinan toteuttaminen',
        financialPlan: 'Varainhankinta',
        previousYear: {
          title: 'Edellisen vuoden talous',
          totalProfitInCents: 'Tilikauden tulos',
          bankAccountSumInCents: 'Pankkitilin saldo, {{lastDayOfPreviousYear}}',
          selfAcquiredFundsInCents: 'Oma varainhankinta',
          receivedGrants: 'Saadut avustukset'
        }
      }
    },
    form: {
      appDetails: {
        title: 'Avustuksen tiedot',
        text: 'Täytä tähän haettavan kohdeavustuksen tiedot ja osallistujat. Tähdellä * merkityt kentät ovat pakollisia.',
        event: {
          name: 'Avustuksen kohde',
          location: 'Paikka',
          startDate: 'Toiminta alkaa',
          endDate: 'Toiminta päättyy'
        },
        purpose: 'Tarkempi käyttötarkoituksen kuvaus',
        appliedTotal: 'Summa €',
        numberOfParticipants:
          'Espoolaisten osallistujien arvioitu / toteutunut määrä',
        participants: {
          ages7to20: {
            label: '7–20-vuotiaat'
          },
          ages21to28: {
            label: '21–28-vuotiaat'
          },
          ages29andOver: {
            label: '29-vuotiaat ja yli'
          },
          total: {
            label: 'Yhteensä'
          }
        },
        totalParticipants: 'Osallistujia yhteensä'
      },
      attachments: {
        title: 'Liitteet',
        text: 'Lisää tähän haluamasi liitteet, esim. kuittikopiot.'
      },
      delete: {
        title: 'Haluatko varmasti poistaa hakemuksen?',
        text: 'Hakemus ja sen tiedot poistetaan järjestelmästä',
        action: 'Poista hakemus'
      },
      expensesAndIncomes: {
        title: 'Menot ja tulot',
        expenses: {
          description: 'Meno (kuvaus)',
          amount: 'Summa €',
          totalSum: 'Yhteensä menot:',
          delete: 'Poista meno',
          add: 'Lisää rivi',
          title: 'Menot'
        },
        incomes: {
          description: 'Tulo (kuvaus)',
          amount: 'Summa €',
          totalSum: 'Yhteensä tulot:',
          delete: 'Poista tulo',
          add: 'Lisää rivi',
          title: 'Tulot'
        }
      },
      newApplication: 'Uusi hakemus',
      orgInfo:
        'Tarkista että yhteisön ja nimenkirjoittajien yhteystiedot ovat oikein, lisää vielä avustuksen täydentävät yhteisötiedot.',
      saveAndClose: 'Tallenna ja sulje',
      signing: {
        title: 'Allekirjoitus',
        text: 'Allekirjoitussivulta voit tarkistaa tiedot ennen allekirjoitusta.'
      },
      toSigning: 'Siirry allekirjoitukseen'
    },
    home: {
      orgs: {
        title: 'Rekisteröidyt yhteisöt',
        createOrgAction: 'Lisää yhteisö'
      },
      org: {
        apps: {
          actions: {
            open: 'Avaa hakemus',
            delete: 'Poista hakemus'
          },
          columns: {
            grantPeriod: 'Hakukausi',
            eventName: 'Avustuksen kohde',
            workgroupEventLabel: 'työryhmä',
            status: 'Tila',
            appliedSum: 'Haettu',
            decisionSum: 'Päätös'
          },
          statusDesc: {
            payImmediately: 'Maksetaan heti',
            postReportApproved: 'Selvitys hyväksytty',
            postReportPaymentWait:
              'Maksetaan heti, toimita selvitys {{dueDate}} mennessä',
            postReportPending: 'Odottaa selvitystä {{dueDate}} mennessä',
            preReportApproved: 'Selvitys hyväksytty, maksetaan {{amount}} €',
            preReportRejected: 'Selvitys hylätty',
            preReportWait: 'Toimita selvitys {{dueDate}} mennessä',
            recovery:
              'Selvitys hylätty, palautettava {{amount}} € {{dueDate}} mennessä',
            recovered: 'Palautettu takaisin {{amount}} €'
          }
        },
        applyForGrant: {
          title: 'Hae kohdeavustusta',
          date: '{{date}} mennessä',
          titleAndDate: 'Hae kohdeavustusta {{date}} mennessä',
          YOUTH_PROJECT_GRANT: 'Hae kohdeavustusta',
          YOUTH_GENERAL_GRANT: 'Hae yleisavustusta'
        },
        incompleteApps: 'Keskeneräisiä hakemuksia: {{count}}',
        showDetails: 'Näytä kaikki hakijatiedot'
      }
    },
    landing: {
      browserSupport: {
        unsupportedBrowser: 'Käyttämääsi selainta ei tueta.',
        info: 'Järjestelmä tukee vain uusimpia Chromen ja Firefoxin versioita.'
      },
      welcome: {
        title: 'Tervetuloa hakemaan nuorisoavustusta!',
        subtitle: 'Kirjaudu Suomi.fi-tunnistuksella!',
        button: 'Suomi.fi-tunnistus'
      }
    },
    preview: {
      attachments: {
        app: {
          title: 'Hakemuksen liitteet'
        },
        report: {
          title: 'Selvityksen liiteet'
        }
      },
      close: 'Sulje',
      expensesAndIncomes: {
        title: 'Menot ja tulot',
        expenses: {
          total: 'Menot yhteensä:',
          title: 'Menot'
        },
        incomes: {
          total: 'Tulot yhteensä:',
          title: 'Tulot'
        }
      },
      processSteps: {
        APPLICATION: {
          title: 'Hakemus'
        },
        DECISION: {
          title: 'Päätös',
          REVIEW: 'Käsittelyssä',
          REJECTED: 'Ei myönnetä',
          GRANTED_PAY_IMMEDIATELY: 'Myönnetään {{amount}} €, maksetaan heti',
          GRANTED_PAY_IMMEDIATELY_WAIT_REPORT:
            'Myönnetään {{amount}} €, odottaa selvitystä',
          GRANTED_PAY_AFTER_REPORT:
            'Myönnetään {{amount}} €, maksetaan selvityksen jälkeen'
        },
        PRE_REPORT: {
          title: 'Selvitys',
          PENDING: 'Viimeistään {{dueDate}}',
          APPROVED: 'Selvitys hyväksytty, maksetaan {{amount}} €',
          REJECTED: 'Selvitys hylätty'
        },
        PAYMENT: {
          title: 'Maksatus',
          PAID: 'Maksettu {{amount}} €',
          REJECTED: 'Ei makseta',
          ACTIVE: 'Käsittelyssä'
        },
        POST_REPORT: {
          title: 'Selvitys',
          ACTIVE: 'Viimeistään {{dueDate}}',
          APPROVED: 'Selvitys hyväksytty',
          REJECTED: 'Selvitys hylätty'
        },
        RECOVERY: {
          title: 'Takaisinperintä',
          PENDING: 'Peritään {{amount}} € viimeistään {{dueDate}} mennessä',
          COMPLETED: 'Palautettu {{amount}} €'
        }
      },
      signing: {
        signedAt: 'Allekirjoittanut: {{date}}'
      }
    },
    signing: {
      await: {
        title:
          'Allekirjoitus lisätty! Hakemukseen tarvitaan vielä toinen allekirjoitus.',
        text: 'Toisen edustajan tulee kirjautua palveluun ja allekirjoittaa hakemus',
        controls: {
          confirm: 'ok'
        }
      },
      close: 'Sulje',
      confirm: {
        title: 'Olet allekirjoittamassa hakemusta',
        text: {
          sendAfterSign:
            'Allekirjoituksen jälkeen hakemus lähetetään. Lähetettyä hakemusta ei voi enää muokata.',
          awaitAfterSign:
            'Allekirjoituksen jälkeen hakemus jää vielä odottamaan toista allekirjoitusta.'
        },
        controls: {
          cancel: 'Peruuta',
          confirm: 'Allekirjoita'
        }
      },
      edit: 'Muokkaa hakemusta',
      link: {
        label: 'Avustusohjeet',
        url: 'https://www.espoo.fi/fi/nuorisoavustukset#section-19216'
      },
      org: {
        check:
          'Olen tarkistanut yhteisön ja hakemuksen tiedot oikeiksi. Olen yli 18-vuotias ja minulla on oikeus allekirjoittaa hakemus yhteisön puolesta.',
        notConfirmed: {
          title: 'Yhteisön ja hakemuksen tietoja ei ole vahvistettu',
          text: 'Tarkista yhteisön ja hakemuksen tiedot ja vahvista ne napauttamalla "Olen tarkistanut yhteisön ja hakemuksen tiedot oikeiksi" valintalaatikkoa.'
        },
        signers: 'Yhteisön nimenkirjoittajat:',
        signingInfo:
          'Allekirjoittaessaan hakija sitoutuu antamaan kokonaisselvityksen hankkeen talouden toteutumisesta avustuspäätöksessä mainittavaan päivämäärään mennessä ja palauttamaan myönnetyn avustuksen takaisin, mikäli hakija rikkoo liikunta- ja nuorisolautakunnan avustuksista annettuja ohjeita (',
        signingInfo2:
          '). Hakija sitoutuu myös pitämään tilinsä ja hallintonsa avoimina kaupungin järjestämää tilintarkastusta varten.'
      },
      orgInfo:
        'Tarkista, että yhteisön ja allekirjoittajien yhteystiedot ovat oikein.',
      sign: 'Allekirjoita',
      success: {
        title: 'Hakemus allekirjoitettu ja lähetetty',
        text: '',
        controls: {
          confirm: 'ok'
        }
      }
    }
  }
}

export type FI = typeof fi
